import { createContext, MutableRefObject, useContext } from 'react';
import { UseQueryResult } from '@tanstack/react-query';

import {
  ActiveFacetsType,
  SearchInstanceDto,
  SearchOptionType,
  SearchResultsDto,
  SearchResultsErrorsDto,
  SearchState,
  SearchStateInitialized,
} from '@app/components';
import { DateRange } from '@app/utils';
import { SetState } from '@app/constants';

export const SearchContext = createContext<SearchContextProps>(null!);

interface Results {
  searchResultsQuery: UseQueryResult<SearchResultsDto, SearchResultsErrorsDto>;
  pages: Array<SearchInstanceDto[] | undefined>;
  totalRecords: number;
  currentPage?: SearchInstanceDto[];
}

export interface SearchContextProps {
  state: SearchStateInitialized;
  searchOption: SearchOptionType;
  searchResults: Results;
  activeFacets: ActiveFacetsType;
  activePublicationYear: DateRange;
  shouldRefocusRef: MutableRefObject<boolean>;
  instanceIdScrollTo: string | null;
  isPageFromBackButton: boolean;
  updateState: SetState<Partial<SearchState>>;
  setActiveFacets: SetState<ActiveFacetsType>;
  setActivePublicationYear: SetState<DateRange>;
  setSearchOption: SetState<string>;
  setInstanceIdScrollTo: SetState<string | null>;
  setIsPageFromBackButton: SetState<boolean>;
}

export const useSearchContext = (): SearchContextProps =>
  useContext(SearchContext);
